import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class MaintenanceModeService {
  showMaintenanceMode = signal<boolean>(false);
  showSiteRedirectNotice = signal<boolean>(false);
}
